import styled from 'styled-components';

export default styled.div`
  justify-self: end;
`;
